export default class BillingPlan {
  constructor(data, features) {
    this.name = data.plan
    this.displayName = data.display_name
    this.features = features
  }

  isPlan(name) {
    return this.name === name
  }

  isAppSumoPlan() {
    return typeof this.name === 'string' && this.name.startsWith('appsumo_')
  }

  isSame(displayName) {
    return (
      this.displayName.trim().toLowerCase() === displayName.trim().toLowerCase()
    )
  }

  hasFeature(feature) {
    return this.features.includes(feature)
  }
}
